import { createHttpClient } from "../utils/http-client";
import { authMiddleware } from "./middlewares/auth.middleware";
import { forbiddenMiddleware } from "./middlewares/forbidden.middleware";
import { refreshMiddleware } from "./middlewares/refresh.middleware";

type ApiHandlers = {
    getAccessToken: () => string | null;
    refreshToken: () => Promise<string | null>;
    onSessionExpired: () => void;
    onForbidden: () => void;
};

const handlers: ApiHandlers = {
    getAccessToken: () => null,
    refreshToken: async () => null,
    onSessionExpired: () => { },
    onForbidden: () => { },
};

export const setupApiHandlers = (h: ApiHandlers) => { Object.assign(handlers, h) };

export const apiClient = createHttpClient(
    {
        baseUrl: import.meta.env.VITE_API_URL,
        requestMiddlewares: [
            authMiddleware(() => handlers.getAccessToken())
        ],
        responseMiddlewares: [
            refreshMiddleware(
                () => handlers.refreshToken(),
                () => handlers.onSessionExpired(),
            ),
            forbiddenMiddleware(() => handlers.onForbidden())
        ]
    }
);